import * as React from "react";
import cn from "classnames";
import styles from "./StepsCounter.module.css";
export function StepsCounter(props) {
    return (React.createElement("div", { className: cn(styles.stepsCounter, props.blueBackground && styles.whiteCounter) },
        props.activeStepIndex,
        " \u0438\u0437 ",
        props.stepsCount));
}
